import { render, staticRenderFns } from "./VocabCardData.vue?vue&type=template&id=525dd952&scoped=true"
import script from "./VocabCardData.vue?vue&type=script&lang=js"
export * from "./VocabCardData.vue?vue&type=script&lang=js"
import style0 from "./VocabCardData.vue?vue&type=style&index=0&id=525dd952&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "525dd952",
  null
  
)

export default component.exports